export default "__VITE_ASSET__BYOjw7Jn__"